import _ from "lodash";
import vm from "../main";
import { httpClient as http } from "../services";

const internals = {};

internals.addWasteType = (wasteType) => {
  const promises = [];
  return http
    .post("waste-type/create", {
      wCName: wasteType.wCName,
      wSubCName: wasteType.wSubCName,
    })
    .then((result) => {
      wasteType = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("authService.inviteUser-error:\n", error);
      throw error;
    });
};

internals.addwasteSubcategory = (wasteType) => {
  const promises = [];
  return http
    .post("waste-type/sub/create", {
      wSubCName: wasteType.wSubCName,
      wCId: wasteType.wCId,
    })
    .then((result) => {
      wasteType = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("authService.inviteUser-error:\n", error);
      throw error;
    });
};

internals.deleteSubCategory = (Id) => {
  return http
    .delete(`/subCategory/delete?_id=${Id}`)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("authService.inviteUser-error:\n", error);
      throw error;
    });
};

internals.getWasteTypebyId = (Id) => {
  return http
    .get(`/waste-type/byId?_id=${Id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("authService.getUser-error:\n", error);
      throw error;
    });
};

internals.updateWasteType = (wasteType) => {
  const promises = [];
  return http
    .put("/waste-type/category/update", {
      _id: wasteType._id,
      wCName: wasteType.wCName,
      status: wasteType.status,
    })
    .then((result) => {
      wasteType = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("authService.inviteUser-error:\n", error);
      throw error;
    });
};

internals.updateWasteSubType = (wasteType) => {
  const promises = [];
  return http
    .put("/waste-type/subCategory/update", wasteType)
    .then((result) => {
      wasteType = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("authService.inviteUser-error:\n", error);
      throw error;
    });
};

internals.updateWasteTypeStatus = (wasteType) => {
  const promises = [];
  return http
    .put("waste-type/category/update", {
      wCName: wasteType.wCName,
      status: wasteType.status,
      _id: wasteType._id,
    })
    .then((result) => {
      wasteType = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("authService.inviteUser-error:\n", error);
      throw error;
    });
};

export default internals;



// WEBPACK FOOTER //
// ./src/services/wasteType.service.js